var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 53.284,
    viewBox: "0 0 58 53.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5624",
    "data-name": "Raggruppa 5624",
    transform: "translate(15313 -10404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19763",
    "data-name": "Tracciato 19763",
    d: "M26.513,14.858a1.1,1.1,0,0,0-1.226-.958,1.071,1.071,0,0,0-.673.345l.223.207a.9.9,0,0,0,.979,1.13,1.345,1.345,0,0,0,.19-.045l.219.2a1.093,1.093,0,0,0,.287-.878",
    transform: "translate(-15305.342 10408.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19764",
    "data-name": "Tracciato 19764",
    d: "M26.03,2.07c1.6,0,7.484.911,16.131,12.637l.346-.241C36.632,5.408,30.468,0,26.03,0S15.429,5.41,9.547,14.468l.35.243C18.545,2.981,24.431,2.07,26.03,2.07",
    transform: "translate(-15310.03 10404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19765",
    "data-name": "Tracciato 19765",
    d: "M18.763,45.163c-1.5-.085-14.737-.941-16.369-4.593-1.013-2.3-1-8.2,1.425-15.7l-.4-.142C-.079,33.911-.9,39.832.987,42.331c1.049,1.286,4.43,2.25,9.777,2.787,2.325.232,5.007.389,7.981.469Z",
    transform: "translate(-15313 10411.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19766",
    "data-name": "Tracciato 19766",
    d: "M37.925,45.119c5.345-.536,8.725-1.5,9.78-2.791,1.883-2.494,1.063-8.415-2.436-17.6l-.4.14c2.426,7.5,2.437,13.4,1.421,15.708-1.626,3.646-14.862,4.5-16.364,4.589l.017.423c2.976-.079,5.663-.235,7.981-.471",
    transform: "translate(-15303.689 10411.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19767",
    "data-name": "Tracciato 19767",
    d: "M26.976,25.753c8.9,0,20.065,14.365,20.178,14.511l.3-.216a76.959,76.959,0,0,0-6.771-8.673c-5.272-5.781-9.885-8.708-13.71-8.708s-8.44,2.928-13.709,8.708a76.808,76.808,0,0,0-6.773,8.673l.3.216c.113-.147,11.28-14.511,20.179-14.511",
    transform: "translate(-15310.98 10411.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19768",
    "data-name": "Tracciato 19768",
    d: "M14.493,32.207A15.753,15.753,0,0,1,26.835,10.448l.5-.08a2.818,2.818,0,0,1,1.378-.354,2.518,2.518,0,0,1,1.255.328L28.3,12.469l3.531,3.27.067.541,7.3,6.755a.543.543,0,0,1,.17.336.727.727,0,0,1,0,.094l-.041,1.253-1.961.657a.8.8,0,0,1-.161.038.752.752,0,0,1-.691-.3l-.57-.772L30.581,21.8l-.324.186a3.419,3.419,0,0,1-1.7.452,3.417,3.417,0,0,1-3.389-3.005l-.371.028c.062,2.8,1.895,4.669,4.346,4.371a4.827,4.827,0,0,0,1.485-.427L35,25.48l.361.486a2.178,2.178,0,0,0,2.01.865,2.217,2.217,0,0,0,.458-.1l2.034-.683a1.276,1.276,0,0,0,.886-1.2l.042-1.329a2.291,2.291,0,0,0-.013-.316,1.973,1.973,0,0,0-.621-1.213l-6.908-6.4-.066-.543-2.95-2.731,1.753-2.238-.9-.705a2.464,2.464,0,0,0-1.488-.414,3.079,3.079,0,0,0-2.452,1.07A16.814,16.814,0,0,0,12.235,34.454c.721-.762,1.478-1.518,2.258-2.247",
    transform: "translate(-15309.761 10406.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19769",
    "data-name": "Tracciato 19769",
    d: "M38.663,32.23l-.308-.29A15.755,15.755,0,0,1,15.23,28.8c-.784.6-1.55,1.242-2.285,1.887A16.812,16.812,0,0,0,38.663,32.23",
    transform: "translate(-15308.973 10412.961)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.c9340f99191c1eab537c301166faa76b.svg";
export { ForwardRef as ReactComponent };